import lmsCustomerRoutes from './customers';
import lmsApplicationPortalRoutes from './application_portals';

export default [
  ...lmsCustomerRoutes,
  ...lmsApplicationPortalRoutes,
];
